







































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';

@Component({ name: 'PaymentCancel' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    currentPaymentId: string;

    dialog = false;

    async cancel() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await DepositAccountModule.cancelPayment(this.currentPaymentId);
        }
    }

}
